import React from 'react';
import { BaseButton } from '@repo/common';

/**
 * 2days 버튼 — 공용 BaseButton 위에 2days 색만 입힌다 (모양·크기·눌림·로딩은 BaseButton 그대로).
 *
 *   variant
 *     primary — 초록 (주 행동: Submit · Accept · Save …)
 *     soft    — 연한 초록 (보조 행동: Cancel · Decline · Reject …)
 *     ghost   — 글자만 (덜 중요한 행동: Change expected submit time …)
 *     danger  — 빨강 채움 (지우기 · 반려 · 되돌릴 수 없는 행동)
 *   size  s(30) · m(40, 기본) · l(48)
 *   disabled 이면 2days 의 꺼진 색(연한 초록 바탕 · 흐린 글자)
 *
 * 아이콘이 필요하면 icon 을 넘긴다 (기본은 아이콘 없음). 나머지 속성(onClick · title · aria-* …)은 그대로 넘어간다.
 */

const VARIANT = {
  primary: {
    type: 'primary',
    bgclass: 'bg-green-deep02 border-green-deep02',
    textclass: 'text-grayscale-gray00',
    hoverclass: 'hover:bg-green-deep04 hover:border-green-deep04',
  },
  soft: {
    type: 'secondary',
    bgclass: 'bg-surface-green10 border-0',
    textclass: 'text-text-primary',
    hoverclass: 'hover:bg-green-light02/60',
    activeclass: 'active:bg-green-light02',
  },
  ghost: {
    type: 'text',
    bgclass: 'bg-transparent border-transparent',
    textclass: 'text-text-secondary',
    hoverclass: 'hover:text-text-primary hover:bg-green-deep03/[0.04]',
  },
  danger: {
    type: 'warning',
    bgclass: 'bg-functional-failed03 border-functional-failed03',
    textclass: 'text-grayscale-gray00',
    hoverclass: 'hover:bg-functional-failed04 hover:border-functional-failed04',
  },
};

// 2days 화면 높이 — BaseButton 의 m(38)·s(30)·l(48) 을 40·32·48 로 맞춘다
const SIZE = {
  s: { size: 's', className: 'h-8 px-3.5 text-[13px]' },
  m: { size: 'm', className: 'h-10 px-5 text-[14px]' },
  l: { size: 'l', className: 'h-12 px-6 text-[15px]' },
};

const TdButton = ({
  variant = 'primary',
  size = 'm',
  disabled = false,
  loading = false,
  icon,
  className,
  children,
  type = 'button',
  ...props
}) => {
  const v = VARIANT[variant] ?? VARIANT.primary;
  const s = SIZE[size] ?? SIZE.m;
  return (
    <BaseButton
      type={v.type}
      htmlType={type}
      size={s.size}
      rounded
      hideIcon={!icon}
      icon={icon}
      isDisabled={disabled}
      isLoading={loading}
      typo={false}
      // BaseButton 은 bgclass 를 꺼진 색 뒤에 붙인다 — 꺼졌을 때는 넘기지 않아야 꺼진 색이 보인다
      bgclass={disabled ? undefined : v.bgclass}
      textclass={disabled ? undefined : v.textclass}
      hoverclass={disabled ? undefined : v.hoverclass}
      activeclass={disabled ? undefined : v.activeclass}
      disabledBgClass='bg-green-deep03/[0.08] border-transparent'
      disabledTextClass='text-text-placeholder'
      className={`${s.className} font-medium ${className ?? ''}`}
      {...props}
    >
      {children}
    </BaseButton>
  );
};

export default TdButton;
